import script from "./PathologyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PathologyCard.vue?vue&type=script&setup=true&lang=js"

import "./PathologyCard.vue?vue&type=style&index=0&id=8e2c1f46&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e2c1f46"]])

export default __exports__